/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-title-align',
  templateUrl: './theme-option-tooltips-title-align.component.html',
  styleUrls: ['./theme-option-tooltips-title-align.component.css']
})
export class ThemeOptionTooltipsTitleAlignComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_titleAlign';
  values = ['left', 'center', 'right'];

  constructor() {}

  onValue(value: string) {
    this.themeOptions.setOption('tooltips_titleAlign', value);
  }

}
